<div class="content-wrapper pb-5">
  <div class="page-title-box d-flex align-items-center justify-content-between mb-4">
    <h4 class="page-title m-0">
      <i class="fas fa-history text-primary mr-2"></i> Historial de Importaciones
    </h4>
    <div class="actions">
      <button mat-raised-button color="warn" *ngIf="histories.length > 0 && !isLoading" (click)="confirmClearHistory()">
        <i class="fas fa-trash-alt mr-2"></i> Borrar Historial
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-5">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && histories.length === 0" class="card text-center p-5 shadow-sm border bg-white">
    <div class="card-body">
      <i class="fas fa-folder-open fa-4x text-muted mb-3"></i>
      <h5 class="text-dark font-weight-bold">No hay importaciones registradas</h5>
      <p class="text-muted">Aún no se ha completado ninguna importación de padrón o farmacias en el sistema.</p>
    </div>
  </div>

  <div *ngIf="!isLoading && histories.length > 0" class="history-list">
    <div class="card mb-4 shadow-sm border bg-white" *ngFor="let run of histories">
      <!-- Encabezado de la importación -->
      <div class="card-header d-flex flex-wrap align-items-center justify-content-between p-3" 
           [style.border-left]="'5px solid ' + tipoBorderColor(run.tipo)"
           style="background-color: #f8f9fa;">
        <div>
          <span class="badge p-2 mr-2" [ngClass]="tipoBadgeClass(run.tipo)">
            <i class="fas" [ngClass]="tipoIcon(run.tipo)"></i> 
            {{ tipoLabel(run.tipo) }}
          </span>
          <strong class="text-dark">{{ run.gerenciadoraName }}</strong>
          <span class="text-muted mx-2">|</span>
          <span class="small text-muted font-italic"><i class="fas fa-file mr-1"></i> {{ run.filename }}</span>
        </div>
        <div class="text-right">
          <span class="text-muted small"><i class="fas fa-calendar-alt mr-1"></i> {{ run.fecha | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>

      <!-- Resumen de Métricas (Idéntico a la UI de Importación Completada) -->
      <div class="card-body p-4">
        <!-- Banner de éxito similar al alert del wizard -->
        <div class="alert alert-success border-success shadow-sm mb-4" style="background-color: #eafaf1; border-left: 4px solid #28a745;">
          <div class="d-flex align-items-center">
            <i class="fas fa-check-circle fa-2x mr-3 text-success"></i>
            <div>
              <h6 class="alert-heading mb-1 font-weight-bold">¡Detalle de la Importación!</h6>
              <p class="mb-0 small text-dark">
                Se procesaron un total de <b>{{ run.totalRecords }}</b> registros de origen para esta importación.
              </p>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <!-- Estadísticas de Ubicación -->
          <div class="col-md-6 mb-3 mb-md-0">
            <div class="p-3 border rounded bg-light h-100">
              <h6 class="font-weight-bold text-dark border-bottom pb-2 mb-3">
                <i class="fas fa-chart-pie text-primary mr-2"></i> Estadísticas de Ubicación
              </h6>
              <p class="mb-2"><i class="fas fa-map-marker-alt text-success mr-2"></i> Geolocalizadas: <b>{{ run.geolocatedCenters }}</b></p>
              <p class="mb-0 text-danger"><i class="fas fa-search-location mr-2"></i> Sin coordenadas: <b>{{ run.unmatchedCenters }}</b></p>
            </div>
          </div>

          <!-- Consolidación de Centros -->
          <div class="col-md-6">
            <div class="p-3 border rounded bg-white border h-100">
              <h6 class="font-weight-bold text-dark border-bottom pb-2 mb-3">
                <i class="fas fa-hospital-user text-success mr-2"></i> Consolidación de Centros
              </h6>
              <p class="small text-muted mb-2">
                Locales consolidados creados u omitidos en la base de datos de Signo Médico.
              </p>
              <div class="d-flex justify-content-around bg-light p-2 rounded text-center">
                <div>
                  <small class="text-muted d-block">Creados</small>
                  <strong class="text-success">{{ run.createdCount }}</strong>
                </div>
                <div class="border-right my-1"></div>
                <div>
                  <small class="text-muted d-block">Omitidos</small>
                  <strong class="text-info">{{ run.skippedCount || 0 }}</strong>
                </div>
                <div class="border-right my-1"></div>
                <div>
                  <small class="text-muted d-block">Fallidos</small>
                  <strong class="text-danger">{{ run.failedCount || 0 }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Acordeón de Fallidos/Errores si los hay -->
        <mat-accordion *ngIf="run.detallesFallidos && run.detallesFallidos.length > 0">
          <mat-expansion-panel class="border border-danger" style="border-left: 4px solid #dc3545;">
            <mat-expansion-panel-header class="bg-light">
              <mat-panel-title class="text-danger font-weight-bold">
                <i class="fas fa-exclamation-triangle mr-2 mt-1"></i> Errores de Importación ({{ run.detallesFallidos.length }})
              </mat-panel-title>
              <mat-panel-description class="text-danger small">
                Clic para expandir el detalle de fallas
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="table-responsive mt-3" style="max-height: 250px; overflow-y: auto;">
              <table class="table table-sm table-hover table-striped mb-0 border">
                <thead class="bg-light sticky-top">
                  <tr>
                    <th class="py-2 pl-3">Nombre / Local</th>
                    <th class="py-2">Domicilio</th>
                    <th class="py-2 pr-3">Motivo del Error</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let fail of run.detallesFallidos">
                    <td class="pl-3 align-middle font-weight-bold text-dark">{{ fail.nombre }}</td>
                    <td class="align-middle small">{{ fail.domicilio }}</td>
                    <td class="pr-3 align-middle text-danger small font-weight-bold">{{ fail.error }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- Listado de creados (Si es farmacia y tiene creados) -->
        <mat-accordion class="mt-2 d-block" *ngIf="run.detallesCreados && run.detallesCreados.length > 0">
          <mat-expansion-panel class="border border-success" style="border-left: 4px solid #28a745;">
            <mat-expansion-panel-header class="bg-light">
              <mat-panel-title class="text-success font-weight-bold">
                <i class="fas fa-check-circle mr-2 mt-1"></i> Locales Creados con Éxito ({{ run.detallesCreados.length }})
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div style="max-height: 250px; overflow-y: auto;" class="p-2">
              <ul class="list-group list-group-flush">
                <li class="list-group-item py-1 small text-dark" *ngFor="let name of run.detallesCreados">
                  <i class="fas fa-hospital-symbol text-success mr-2"></i> {{ name }}
                </li>
              </ul>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>

  <!-- Botón Volver -->
  <div class="mt-4">
    <a class="btn-ghost" [routerLink]="['/padrones-administracion']">
      <i class="fas fa-arrow-left mr-2"></i> Volver a Gestión de Padrones
    </a>
  </div>
</div>
